import React from 'react';
import { Modal, ModalHeader, ModalBody, Box, Text, useBreakpointValue, } from '@spothero/ui';
import { UpcomingEvents } from '../../landing/UpcomingEventsLanding';
import { NotGoingToEvent } from '../../not-going-to-event/NotGoingToEvent';
import { useDispatch, useSelector } from 'react-redux';
import { setSearchComponentEventView, setSearchComponentIsOpen, } from 'store/search/search-actions';
import useIsMobile from 'hooks/use-is-mobile';
import { useAddHideEventModal } from 'utils/url/add-hide-event-modal/add-hide-event-modal';
export const EventsPopup = () => {
    const eventView = useSelector((state) => state.search.data.searchComponentEventView);
    const modalOpen = useSelector((state) => state.search.data.eventsPopupOpen);
    const showByButton = eventView === 'selectWFilter';
    const destinationTitle = useSelector((state) => state.destination.data.title);
    const dispatch = useDispatch();
    const isMobile = useIsMobile('mobileXL');
    const addHideEventModal = useAddHideEventModal();
    const eventsPageSize = useBreakpointValue({ base: 3, desktop: 5 }, { ssr: false });
    const handleHide = () => {
        dispatch(setSearchComponentEventView(null));
        dispatch(setSearchComponentIsOpen(false));
        addHideEventModal(); // Add hide event modal to query params
    };
    if (isMobile) {
        return <div date-testid="desktop-events-popup-hidden"/>;
    }
    return (<Modal hasHeader size="md" isOpen={showByButton || modalOpen} onClose={handleHide} contentStyling={{
            minHeight: 'unset',
            maxHeight: '80vh',
            marginTop: { base: 'auto', tablet: '16' },
            marginBottom: { base: 'auto', tablet: '16' },
            marginLeft: { base: '4', tablet: 'auto' },
            marginRight: { base: '4', tablet: 'auto' },
        }}>
            <ModalHeader data-testid="EventsPopup-header" sx={{
            width: 'calc(100% - 50px)', // leave space for the [x] button
        }}>
                Find and reserve parking near {destinationTitle}
            </ModalHeader>
            <ModalBody data-testid="EventsPopup-body" flexDirection={{ base: 'column', tablet: 'row' }}>
                <Box flex={{
            tablet: '1 1 80%',
            desktop: '1 1 65%',
            desktopXL: '1 1 50%',
        }} display="grid" gridTemplateRows="min-content" borderRight={{
            base: 'none',
            tablet: '1px solid var(--chakra-colors-gray-200)',
        }} paddingRight={{ tablet: 4, desktopXL: 8 }} sx={{
            'a svg': {
                color: 'black',
            },
        }}>
                    <Text fontWeight="medium" fontSize="sm" paddingTop="4">
                        Upcoming Events
                    </Text>
                    <UpcomingEvents pageSize={eventsPageSize}/>
                </Box>
                <Box flex={{ desktop: '1 1 auto' }} borderTop={{
            base: '1px solid var(--chakra-colors-gray-200)',
            tablet: 'none',
        }} paddingLeft={{ tablet: 4, desktopXL: 8 }} sx={{
            'a svg': {
                color: 'black',
            },
        }}>
                    <NotGoingToEvent />
                </Box>
            </ModalBody>
        </Modal>);
};
